import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { auth } from "@/lib/firebase/client";

function OnboardingLayout() {
  return <Outlet />;
}

export const Route = createFileRoute("/onboarding")({
  beforeLoad: async () => {
    if (typeof auth.authStateReady === "function") {
      await auth.authStateReady();
    }
    if (!auth.currentUser) {
      throw redirect({ to: "/signin" });
    }
  },
  component: OnboardingLayout,
});
